import request from '@/utils/request'

// 我的成就

let BadgeApi = {

    /*列表*/
    getList(data, errorback) {
        return request._post('/shop/study.badge/index', data, errorback);
    },

    /*添加*/
    add(data, errorback) {
        return request._post('/shop/study.badge/add', data, errorback);
    },

    /*删除*/
    del(data, errorback) {
        return request._post('/shop/study.badge/del', data, errorback);
    },

    /*编辑*/
    edit(data, errorback) {
        return request._post('/shop/study.badge/edit', data, errorback);
    }
}

export default BadgeApi;



// WEBPACK FOOTER //
// ./src/api/study/badge.js